(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[419],{

/***/ 76647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _var_www_vhosts_investin_am_httpdocs_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64167);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35135);
/* harmony import */ var components_pages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4617);
/* harmony import */ var styles_pages_CompanyStyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66449);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69494);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);

var _excluded = ["pages", "pageParams", "selectedLang", "preloader"];
 //* HOC's


 //* Components



 //* Helpers




var CompanyProjects = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (_ref) {
  var _companyData$company, _companyData$company2, _companyData$company3, _pageData$contact_sec, _pageData$contact_sec2, _pageData$contact_sec3;

  var pages = _ref.pages,
      pageParams = _ref.pageParams,
      selectedLang = _ref.selectedLang,
      preloader = _ref.preloader,
      props = (0,_var_www_vhosts_investin_am_httpdocs_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  //! Router
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(); //! State

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      secObj = _useState[0],
      setSecObj = _useState[1]; //! Page Data


  var pageData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var _pages$pageParams$nam;

    return pages === null || pages === void 0 ? void 0 : (_pages$pageParams$nam = pages[pageParams.name]) === null || _pages$pageParams$nam === void 0 ? void 0 : _pages$pageParams$nam[selectedLang];
  }, [pages, selectedLang, pageParams.name]);
  var companyData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var _props$pageParams$sin, _props$pageParams$sin2;

    return (_props$pageParams$sin = props[pageParams.singleType]) === null || _props$pageParams$sin === void 0 ? void 0 : (_props$pageParams$sin2 = _props$pageParams$sin[router.query.slug]) === null || _props$pageParams$sin2 === void 0 ? void 0 : _props$pageParams$sin2[selectedLang];
  }, [props === null || props === void 0 ? void 0 : props[pageParams.singleType], router, selectedLang]); //! ref

  var topRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var catalogViewRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var Ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (pageData && companyData && topRef !== null && topRef !== void 0 && topRef.current && catalogViewRef !== null && catalogViewRef !== void 0 && catalogViewRef.current && Ref4.current && !preloader) {
      setSecObj([(0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .arrayGenChild */ .YJ)(topRef.current[0].current.firstChild.childNodes), (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .arrayGen */ .vN)([topRef.current[1].current.childNodes]), (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .arrayGenChild */ .YJ)(catalogViewRef.current[0].current.childNodes[0].childNodes), catalogViewRef.current[2].current.childNodes, catalogViewRef.current[3].current, (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .arrayGenChild */ .YJ)(Ref4.current[0][0].childNodes), Ref4.current[1].current, Ref4.current[2].current]);
    }
  }, [topRef.current, catalogViewRef.current, Ref4.current, router, pageData, companyData, preloader]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(styles_pages_CompanyStyle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_3__/* .Page */ .T3, {
      className: "company-projects",
      meta: {
        title: companyData === null || companyData === void 0 ? void 0 : (_companyData$company = companyData.company) === null || _companyData$company === void 0 ? void 0 : _companyData$company.meta.title,
        description: companyData === null || companyData === void 0 ? void 0 : (_companyData$company2 = companyData.company) === null || _companyData$company2 === void 0 ? void 0 : _companyData$company2.meta.description,
        keywords: companyData === null || companyData === void 0 ? void 0 : (_companyData$company3 = companyData.company) === null || _companyData$company3 === void 0 ? void 0 : _companyData$company3.meta.keywords,
        image: companyData === null || companyData === void 0 ? void 0 : companyData.company.meta_image
      },
      children: companyData && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(components_common__WEBPACK_IMPORTED_MODULE_3__/* .AnimationWrapp */ .dh, {
        state: secObj,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_4__/* .CompanyInfo */ .zW, {
          ref: topRef,
          backPage: 'investmentProjects',
          id: companyData.company.id,
          companyName: companyData.company.name,
          companyType: companyData.company.type,
          companyInfo: companyData.company.short_description,
          projectsCompany: true,
          backURL: helpers__WEBPACK_IMPORTED_MODULE_6__/* .config.routes.investmentProjects.path */ .vc.routes.investmentProjects.path
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_4__/* .CatalogView */ .N1, {
          ref: catalogViewRef,
          notLast: true,
          inProductSubmission: true,
          singleInvest: true,
          title: 'companyProjects',
          catalogsArr: companyData.projects
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_4__/* .BusinessSection */ .vx, {
          ref: Ref4,
          inCompany: true,
          title: (_pageData$contact_sec = pageData.contact_section) === null || _pageData$contact_sec === void 0 ? void 0 : _pageData$contact_sec.title,
          text: (_pageData$contact_sec2 = pageData.contact_section) === null || _pageData$contact_sec2 === void 0 ? void 0 : _pageData$contact_sec2.text,
          photo: ((_pageData$contact_sec3 = pageData.contact_section) === null || _pageData$contact_sec3 === void 0 ? void 0 : _pageData$contact_sec3.image) || '/images/services/business.png'
        })]
      })
    })
  });
});
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_1__/* .withDataContext */ .hX)(CompanyProjects, ['pages', helpers__WEBPACK_IMPORTED_MODULE_6__/* .config.routes.projectsCompanySingle.singleType */ .vc.routes.projectsCompanySingle.singleType]));

/***/ }),

/***/ 66449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87379);

var CompanyStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.attrs */ .ZP.div.attrs(function (props) {
  return {
    className: props.className
  };
}).withConfig({
  componentId: "sc-1r0oonq-0"
})([".company-products{margin-bottom:0;}.company-products,.company-projects{margin-top:calc(var(--pageFromHeaderMargin) + var(--sp2-5x));.catalog-view{.bottom{flex-wrap:wrap;margin-bottom:0;.single-catalog{margin-bottom:var(--sp4x);&:nth-child(4n){margin-left:var(--sp2x);margin-right:0;}&:nth-child(4n-1){margin-left:var(--sp2x);margin-right:var(--sp2x);}&:nth-child(4n-2){margin-left:var(--sp2x);margin-right:var(--sp2x);}&:nth-child(4n-3){margin-right:var(--sp2x);}}}}}@media screen and (max-width:", ") and (min-width:", "){.company-products,.company-projects{.catalog-view{.bottom{flex-wrap:wrap;.single-catalog{margin-bottom:var(--sp3x);width:calc(33.333% - var(--sp2x));&:nth-child(4n){margin-left:unset;margin-right:unset;}&:nth-child(4n-1){margin-left:unset;margin-right:unset;}&:nth-child(4n-2){margin-left:unset;margin-right:unset;}&:nth-child(4n-3){margin-right:unset;}&:nth-child(3n){margin-left:var(--sp1-5x);margin-right:0;}&:nth-child(3n-1){margin-left:var(--sp1-5x);margin-right:var(--sp1-5x);}&:nth-child(3n-2){margin-left:var(--sp1-5x);}}}}}}@media screen and (max-width:", ") and (min-width:", "){.company-products,.company-projects{.catalog-view{.bottom{flex-wrap:wrap;.single-catalog{margin-bottom:var(--sp3x);width:calc(50% - var(--sp1-5x));&:nth-child(4n){margin-left:unset;margin-right:unset;}&:nth-child(4n-1){margin-left:unset;margin-right:unset;}&:nth-child(4n-2){margin-left:unset;margin-right:unset;}&:nth-child(4n-3){margin-right:unset;}&:nth-child(2n){margin-left:var(--sp1-5x);margin-right:0;}&:nth-child(2n-1){margin-right:var(--sp1-5x);}}}}}}@media screen and (max-width:", "){.company-products,.company-projects{.catalog-view{.bottom{flex-wrap:wrap;.single-catalog{margin-bottom:var(--sp2x);width:100%;&:nth-child(4n){margin-left:unset;margin-right:unset;}&:nth-child(4n-1){margin-left:unset;margin-right:unset;}&:nth-child(4n-2){margin-left:unset;margin-right:unset;}&:nth-child(4n-3){margin-right:unset;}}}}}}"], function (props) {
  return props.theme.mediaQuery.DesktopSizeSMin;
}, function (props) {
  return props.theme.mediaQuery.LaptopSize;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.TabletSize;
}, function (props) {
  return props.theme.mediaQuery.TabletSizeMin;
});
/* harmony default export */ __webpack_exports__["Z"] = (CompanyStyle);

/***/ }),

/***/ 5809:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects-company/[slug]",
      function () {
        return __webpack_require__(76647);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(5809); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);